'use strict';
import angular from 'angular';

export default class AppDataController {
    /*@ngInject*/
    constructor($stateParams, $http, $state, Application, $scope, Upload) {
        var vm = this;

        vm.lineTemplate = {
            "1": [
                {
                    selected: false,
                    template: [{grid: 12}]
                }
            ],
            "2": [
                {
                    selected: false,
                    template: [{grid: 6}, {grid: 6}]
                },
                {
                    selected: false,
                    template: [{grid: 9}, {grid: 3}]
                },
                {
                    selected: false,
                    template: [{grid: 3}, {grid: 9}]
                }
            ],
            "3": [
                {
                    selected: false,
                    template: [{grid: 6}, {grid: 3}, {grid: 3}]
                },
                {
                    selected: false,
                    template: [{grid: 3}, {grid: 3}, {grid: 6}]
                }
            ],
            "4": [
                {
                    selected: false,
                    template: [{grid: 3}, {grid: 3}, {grid: 3}, {grid: 3}]
                }
               
            ]
        }
        vm.dataAddLine = {};

        vm.rows = [
            
        ];

        vm.fileUploadTime = Date.now();

        $http.get('/api/applications/' + $stateParams.id).then(
            function(res) {
                var data = res.data;
                Application.load($stateParams.id).then(function() {
                    $scope.$apply(function() {
                        vm.app = Application;
                        vm.rows = Application.data.inputs;
                        console.log(vm.app);
                    }); 
                    
                });
				
            }, function(error) {
                if (error.status == "404") {
                    $state.go('application_main');
                }
                console.log(error);
            });

		
		vm.save = function() {
			//Application.save($stateParams.id);
            _.each(vm.rows, function(row) {
                _.each(row, function(col) {
                    if(col.patternType == 'textMinMax') {
                        if(col.max == undefined || col.max.length == 0) {
                            col.pattern = "[A-Za-z\\- ]{"+col.min+",}";
                        }
                        else {
                            col.pattern = "[A-Za-z\\- ]{"+col.min+","+col.max+"}";
                        }
                    }
                    if(col.patternType == 'textNumberMinMax') {
                        if(col.max == undefined || col.max.length == 0) {
                            col.pattern = "[A-Za-z0-9\\- ]{"+col.min+",}";
                        }
                        else {
                            col.pattern = "[A-Za-z0-9\\- ]{"+col.min+","+col.max+"}";
                        }
                    }
                    if(col.patternType == 'numberMinMax') {
                        if(col.max == undefined || col.max.length == 0) {
                            col.pattern = "[0-9]{"+col.min+",}";
                        }
                        else {
                            col.pattern = "[0-9]{"+col.min+","+col.max+"}";
                        }
                    }
                    if(col.patternType == 'email') {
                        // col.pattern = "[A-Z]+[A-Z0-9.\\-_]+@[A-Z0-9\\-_]+\\.[A-Z.]{2,5}";
                        col.pattern = `^(([^<>()\\[\\]\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$`;
                    }
                    if(col.patternType == 'tel') {
                        if(col.telStartBy.length == 0)
                            col.pattern = "[0-9]{10}";
                        else if(col.telStartBy.length == 1)
                            col.pattern = "^"+col.telStartBy+"[0-9]{9}$";
                        else if(col.telStartBy.length == 2)
                            col.pattern = "^"+col.telStartBy+"[0-9]{8}$";
                    }
                });
            });
            
            Application.data.inputs = vm.rows;
            Application.save($stateParams.id);

		}
        
/*        vm.next = function() {
			Application.save($stateParams.id);
            $state.go('application_screen_preview', { id: $stateParams.id });
		}*/

        vm.next = function() {
            Application.next($stateParams.id);
        }


        vm.upload = function (file) {
            Upload.upload({
                url: '/api/applications/'+$stateParams.id+'/upload/data',
                data: {file: file}
            }).then(function (resp) {
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                vm.fileUploadTime = Date.now();
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };


        vm.selectTemplate = function(template) {
            _.each(vm.lineTemplate, function(dd) {
                _.each(dd, function(ee) {
                    ee.selected = false;
                });
            });
            template.row.selected = true;

            vm.dataAddLine.selectedTemplate = template.row;
        }
        vm.closeAddLine = function() {
            _.each(vm.lineTemplate, function(dd) {
                _.each(dd, function(ee) {
                    ee.selected = false;
                });
            });
            vm.dataAddLine.inputNumber = 0;
            vm.dataAddLine.selectedTemplate = {};
        }
        vm.addLine = function() {
            console.log(vm.dataAddLine.selectedTemplate);
            var row = [];

            _.each(vm.dataAddLine.selectedTemplate.template, function(aa) {

                var size = 0;
                switch(aa.grid) {
                    case 3:
                        size = 25;
                        break;
                    case 6:
                        size = 50;
                        break;
                    case 9:
                        size = 75;
                        break;
                    case 12:
                        size = 100;
                        break;
                }

                row.push({
                    "type": "text",
                    "name": "",
                    "size": size,
                    "placeholder": "",
                    "required": false,
                    "pattern": "",
                    "patternType": "",
                    "ready": false,
                    "choices": []
                });
            });

            vm.rows.push(row);

            vm.closeAddLine();
        }

        vm.deleteLine = function(line) {
            vm.rows.splice(vm.rows.indexOf(line.row), 1);
        }

        vm.convertColSize = function(size) {
            var grid = 0;

            switch(size) {
                case 25:
                    grid = 3;
                    break;
                case 50:
                    grid = 6;
                    break;
                case 75:
                    grid = 9;
                    break;
                case 100:
                    grid = 12;
                    break;
            }
            
            return grid;
            console.log(size);
        }

        vm.inputConfigurationSelected = {};
        vm.inputConfigurationData = {};
        vm.showInputConfiguration = function(input) {
            vm.inputConfigurationSelected = input.col;

            vm.inputConfigurationData = vm.inputConfigurationSelected;

            if(vm.inputConfigurationSelected.type == undefined) {
                vm.inputConfigurationData.type = "text";
            }
            else 
                vm.inputConfigurationData.type = vm.inputConfigurationSelected.type;
        }

        vm.saveInputConfiguration = function() {
            
            vm.inputConfigurationSelected = vm.inputConfigurationData;

            vm.inputConfigurationSelected.ready = true;
            
            vm.inputConfigurationSelected = {};
            vm.inputConfigurationData = {};
        }

        vm.addChoice = function() {
            vm.inputConfigurationData.choices.push({ });
        }
        vm.deleteChoice = function(choice) {
            vm.inputConfigurationData.choices.splice(vm.inputConfigurationData.choices.indexOf(choice.choice), 1);
        }

        $scope.$watch('vm.inputConfigurationData.type', function() {
            if(vm.inputConfigurationData.type != "text") {
                vm.inputConfigurationData.patternType = null;
            }
        });
    }

}


// WEBPACK FOOTER //
// ./client/app/application/data/data.controller.js